import { observer } from 'mobx-react-lite';
import React, { Fragment, SyntheticEvent, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Button, DropdownDivider, Header, Item, Label, List, Segment } from 'semantic-ui-react';
import { Activity } from '../../../app/models/activity';
import { useStore } from '../../../app/stores/store';
import ActivityListItem from './ActivityListItem';

// interface Props {
//     activities: Activity[];
//     //selectActivity: (id: string) => void;
//     //deleteActivity: (id: string) => void;
//     //submitting: boolean; //. loading
// }

//export default function ActivityList(props: Props) { //.'o
export default observer( function ActivityList() {
    //const [target, setTarget] = useState(''); //'o
    const usStore = useStore(); //'.n

    //event: any
    // function handleActivityDelete(event: any, id: string) {
    //     setTarget(event.target.name);
    //     usStore.activityStore.deleteActivity(id);
    // }

    // //React event
    // function handleActivityDelete(event: SyntheticEvent<HTMLButtonElement>, id: string) {
    //     setTarget(event.currentTarget.name);
    //     usStore.activityStore.deleteActivity(id);
    // }

    // return (
    //     <Segment>
    //           <Item.Group divided>

    //             {/* <List> */}
    //                 {/* {props.activities. map((activity: any) => ( */}
    //                 {/* {props.activities. map(activity => (
    //                     <List.Item key={activity.id}>
    //                         {activity.title}
    //                     </List.Item>
    //                 ))}
    //             </List> */}

    //             {usStore.activityStore.activities.map(activity => (
    //                 // <Item key={activity.id}>
    //                 //     <Item.Content>
    //                 //         <Item.Header as='a'>{activity.title}</Item.Header>
    //                 //         <Item.Meta>{activity.date}</Item.Meta>
    //                 //         <Item.Description>
    //                 //             <div>{activity.description}</div>
    //                 //             <div>{activity.city}, {activity.venue}</div>
    //                 //         </Item.Description>
    //                 //         <Item.Extra>
    //                 //             {/* <Button floated='right' content='View' color='blue' /> */}
    //                 //             {/* <Button floated='right' content='View' color='blue' onClick={() => usStore.activityStore.selectActivity(activity.id)} /> */}
    //                 //             <Button floated='right' content='View' color='blue' as={Link} to={`/activities/${activity.id}`}  />

    //                 //             {/* <Button floated='right' content='Delete' color='red' onClick={() => usStore.activityStore.deleteActivity(activity.id)} loading={usStore.activityStore.loading} name={activity.id} /> */}
    //                 //             <Button floated='right' content='Delete' color='red' onClick={(event) => handleActivityDelete(event, activity.id)} loading={usStore.activityStore.loading && target === activity.id} name={activity.id} />
                               
    //                 //             <Label basic content={activity.category} />
    //                 //         </Item.Extra>
    //                 //     </Item.Content>
    //                 // </Item>

    //                 <ActivityListItem activity={activity} key={activity.id} />
    //             ))}
                
    //           </Item.Group>
    //     </Segment>
    // )


    return (
        <Fragment>
            {usStore.activityStore.getGroupedActivities.map(([group, activities]) => (
                <Fragment key={group}>
                    <Header sub color='teal'>
                        {group}
                    </Header>
                    {/* <Segment>
                        <Item.Group divided> */}
                            {activities.map(activity => (
                                <ActivityListItem activity={activity} key={activity.id} />
                            ))}
                        {/* </Item.Group>
                    </Segment> */}
                </Fragment>
            ))}
        </Fragment>
    )

})